"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
var heroCarousel = document.querySelectorAll('[data-swiper="hero"]');
if (heroCarousel) {
    heroCarousel.forEach(function (carousel) {
        var imageSwiperElement = carousel.querySelector('[data-hero-swiper="images"]');
        var contentSwiperElement = carousel.querySelector('[data-hero-swiper="content"]');
        var paginationElement = carousel.querySelector('[data-swiper-pagination]');
        var imageSwiper = new swiper_1.default(imageSwiperElement, {
            modules: [modules_1.Autoplay, modules_1.EffectFade, modules_1.A11y, modules_1.Mousewheel],
            speed: 1500,
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            effect: 'fade',
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            fadeEffect: {
                crossFade: true,
            },
        });
        var contentSwiper = new swiper_1.default(contentSwiperElement, {
            modules: [modules_1.Autoplay, modules_1.EffectFade, modules_1.Pagination, modules_1.A11y, modules_1.Controller, modules_1.Parallax, modules_1.Mousewheel],
            speed: 1500,
            autoplay: {
                delay: 5000,
            },
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 200,
            parallax: true,
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            pagination: {
                el: paginationElement,
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return "<span class=\"".concat(className, "\"><span>").concat(index + 1, "</span></span>");
                },
            },
            controller: {
                by: 'slide',
                control: imageSwiper,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: false,
            },
        });
    });
}
var relatedContentCarousel = document.querySelectorAll('[data-swiper="related_content"]');
if (relatedContentCarousel) {
    relatedContentCarousel.forEach(function (carousel) {
        var swiperElement = carousel.querySelector('.swiper');
        var prevButton = carousel.querySelector('[data-swiper-navigation-prev]');
        var nextButton = carousel.querySelector('[data-swiper-navigation-next]');
        var swiper = new swiper_1.default(swiperElement, {
            modules: [modules_1.Navigation, modules_1.A11y, modules_1.Mousewheel],
            speed: 500,
            loop: false,
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                0: {
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                },
                810: {
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                    slidesPerView: 2,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                },
                1280: {
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                },
                2560: {
                    spaceBetween: 60,
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                },
            },
        });
    });
}
var mediaCarousel = document.querySelectorAll('[data-swiper="media"]');
if (mediaCarousel) {
    mediaCarousel.forEach(function (carousel) {
        var swiperElement = carousel.querySelector('.swiper');
        var paginationElement = carousel.querySelector('[data-swiper-pagination]');
        var swiper = new swiper_1.default(swiperElement, {
            modules: [modules_1.Pagination, modules_1.A11y, modules_1.Mousewheel],
            speed: 500,
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 40,
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            pagination: {
                el: paginationElement,
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return "<span class=\"".concat(className, "\"><span>").concat(index + 1, "</span></span>");
                },
            },
        });
    });
}
var logoCarousel = document.querySelectorAll('[data-swiper="logo"]');
if (logoCarousel) {
    logoCarousel.forEach(function (carousel) {
        var swiperElement = carousel.querySelector('.swiper');
        var paginationElement = carousel.querySelector('[data-swiper-pagination]');
        var swiper = new swiper_1.default(swiperElement, {
            modules: [modules_1.Pagination, modules_1.A11y, modules_1.Mousewheel],
            speed: 500,
            loop: false,
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            breakpoints: {
                0: {
                    slidesPerGroup: 1,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                2560: {
                    slidesPerGroup: 1,
                    slidesPerView: 4,
                    spaceBetween: 60,
                },
            },
            pagination: {
                el: paginationElement,
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return "<span class=\"".concat(className, "\"><span>").concat(index + 1, "</span></span>");
                },
            },
        });
    });
}
var skuComparisonCarousel = document.querySelectorAll('[data-swiper="sku_comparison"]');
if (skuComparisonCarousel) {
    skuComparisonCarousel.forEach(function (carousel) {
        var swiperElement = carousel.querySelector('.swiper');
        var prevButton = carousel.querySelector('[data-swiper-navigation-prev]');
        var nextButton = carousel.querySelector('[data-swiper-navigation-next]');
        var numSlides = swiperElement.querySelectorAll('.swiper-slide').length;
        var slidesPerViewXl = 3.2;
        var slidesPerViewLg = 2.2;
        var slidesPerViewSm = 1.2;
        if (numSlides === 1) {
            slidesPerViewXl = 1;
            slidesPerViewLg = 1;
            slidesPerViewSm = 1;
        }
        else if (numSlides === 2) {
            slidesPerViewXl = 2;
            slidesPerViewLg = 2;
            slidesPerViewSm = 2;
        }
        var swiper = new swiper_1.default(swiperElement, {
            modules: [modules_1.Navigation, modules_1.A11y, modules_1.Mousewheel],
            speed: 500,
            loop: false,
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                0: {
                    slidesPerGroup: 1,
                    slidesPerView: slidesPerViewSm,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerGroup: 1,
                    slidesPerView: slidesPerViewLg,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerGroup: 1,
                    slidesPerView: slidesPerViewXl,
                    spaceBetween: 30,
                },
            },
        });
    });
}
